import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="page-wrapper">
      <section className="page-header">
        <div className="header-container">
          <h1 className="page-title">About ArcaCapitalis</h1>
          <p className="page-subtitle">
            Strategic business building and consulting for entrepreneurs
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="content-container">
          <div className="content-block">
            <h2 className="content-heading">Our Mission</h2>
            <p className="content-text">
              ArcaCapitalis provides strategic business building, analytical research, 
              and operational consulting to entrepreneurs and growing companies. We specialize in delivering 
              structured, professional guidance that helps businesses build strong foundations and 
              achieve sustainable growth.
            </p>
          </div>

          <div className="content-block">
            <h2 className="content-heading">What We Do</h2>
            <p className="content-text">
              Our team delivers comprehensive research services, business consulting, 
              and documentation support. We work with organizations to develop strategic 
              frameworks, improve operational processes, and provide analytical insights 
              that drive informed decision-making.
            </p>
          </div>

          <div className="content-block">
            <h2 className="content-heading">Professional Standards</h2>
            <p className="content-text">
              ArcaCapitalis is a product of ArcaCentum LLC, a U.S.-based limited liability company. 
              We are committed to delivering high-quality professional services and maintain strict 
              standards of accuracy, confidentiality, and professionalism in all client engagements.
            </p>
          </div>

          <div className="content-block">
            <h2 className="content-heading">Important Disclosure</h2>
            <p className="content-text disclosure">
              ArcaCapitalis does not provide investment advice, brokerage services, 
              or asset management. We are not registered as an investment adviser, 
              broker-dealer, or financial services provider. All information and 
              services are provided for business consulting, research, and educational purposes only.
            </p>
          </div>

          <div className="content-cta">
            <Link to="/services" className="btn-primary">
              View Services
            </Link>
            <Link to="/contact" className="btn-secondary">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;